<template>
  <div
    class="accordion"
    :class="{ collapsed: !isOpen }"
    :ref="accordionRef"
    :data-parent="parentRef"
    :data-current="accordionRef"
  >
    <div class="accordion__title" @click="toggleAccordion(accordionRef)">
      <div class="left">
        <img v-if="accordionIcon" :src="accordionIcon" />
        <h4>{{ accordionTitle }}</h4>
      </div>
      <i class="accordion__icon"
        ><img src="@/assets/images/benefits/down-arrow.svg"
      /></i>
    </div>
    <div class="accordion__content">
      <div class="accordion__content__container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance } from "vue";
export default {
  props: ["accordionTitle", "accordionIcon", "isOpen"],
  setup() {
    const instance = getCurrentInstance();
    const parentRef = ref(`Acc_P${instance.parent.uid}`);
    const accordionRef = ref(`Acc_P${instance.parent.uid}-C${instance.uid}`);
    //TODO: This needs work. Remove DOM javascript portion and manage all via Vue3
    //Done this way to be able to comunicate to all other accordions within the same page
    function toggleAccordion(clickRef) {
      document.querySelectorAll(".accordion").forEach((item) => {
        let clickedAccordionParent = clickRef.split("-");
        // console.log(clickedAccordionParent, item.dataset.parentRef, item.dataset.current, clickRef);
        if (
          clickedAccordionParent[0] === item.dataset.parent &&
          item.dataset.current !== clickRef
        ) {
          item.classList.add("collapsed");
        }
        if (item.dataset.current === clickRef) {
          let accordionContent = item.querySelector(".accordion__content");
          let contentHeight = accordionContent.querySelector(
            ".accordion__content__container"
          ).offsetHeight;
          accordionContent.style.height = contentHeight + "px";
          item.classList.toggle("collapsed");
        }
      });
    }
    return {
      parentRef,
      accordionRef,
      toggleAccordion,
    };
  },
};
</script>
<style lang="scss">
.accordion {
  width: 100%;
  &:not(:first-child) {
    margin-top: 10px;
  }
  &__title {
    background-color: #0f2340;
    padding: 0 32.54px 0 19px;
    height: 80px;
    text-transform: uppercase;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: 27px;
      line-height: 28px;
      margin-right: 0;
      position: relative;
      z-index: 2;
      pointer-events: none;
      transition: all 0.4s ease-in-out;
      svg {
        width: 17px;
      }
    }
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        height: 80px;
        object-fit: contain;
      }
    }
    h4 {
      position: relative;
      font-family: Abolition;
      font-weight: normal;
      font-size: 26px;
      line-height: 27px;
      color: #ffffff;
      text-transform: uppercase;
      pointer-events: none;
      z-index: 1;
      margin-bottom: 0;
      padding-right: 20px;
    }
  }
  &__content {
    transition: all 0.4s ease-in-out;
    overflow: hidden;
    &__container {
      background: url("~@/assets/images/faq/accordion-open-bg.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      padding: 38px 32px 50px 38px;
      p {
        font-family: DINPro;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: normal;
        color: #000a12;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }
  }
  &.collapsed {
    .accordion__content {
      height: 0px !important;
    }
  }
  &__title:hover:before,
  &:not(.collapsed) &__title:before {
    opacity: 1;
  }
  &:not(.collapsed) &__title i {
    transform: rotate(180deg);
  }
}
@media screen and (max-width: 600px) {
  .accordion {
    &__title {
      h4 {
        font-size: 24px;
        line-height: 29px;
      }
    }
    &__content {
      .content-container {
        padding: 14px 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.accordion {
  ul {
    padding-left: 16px !important;
    li {
      font-family: DINPro;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: normal;
      color: #000a12;
    }
  }
  .incentiveButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    background-color: #de1e35;
    font-family: Abolition;
    font-weight: normal;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: normal;
    color: #ffffff !important;
    text-transform: uppercase;
    text-decoration: none;
    padding: 11px 25px 12px 25px;
    margin-top: 30px;
    &:hover {
      color: #ffffff;
    }
  }
}
</style>